import { RefObject, useRef } from 'react'
import { TRANSITION_DURATION } from '../LoggedOutCodeGenerator.constants'
import type { SystemStyleObject } from '@mui/system'

export const useLoggedOutGeneratorMobileTransitionStyles = (): {
  generatorHeadingRef: RefObject<HTMLDivElement>
  generatorHeadingTransitionsSx: SystemStyleObject
  codePreviewTransitionsSx: SystemStyleObject
} => {
  const generatorHeadingRef = useRef<HTMLDivElement>(null)
  const generatorHeadingHeight = generatorHeadingRef.current?.clientHeight ?? 0
  const codePreviewTransformDistance = `calc((100% - ${
    generatorHeadingHeight *
    2 /* times 2 because we're already transforming by the generator heading height when removing the heading */
  }px) * -1)`
  const exitDoneStyles = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0
  }
  const transition = `opacity ${TRANSITION_DURATION}ms, transform ${TRANSITION_DURATION}ms ease-in-out, margin-bottom ${TRANSITION_DURATION}ms ease-in-out`
  const enterActiveStyles = {
    opacity: 1,
    transform: 'none',
    marginBottom: 0,
    transition
  }
  const exitStyles = {
    opacity: 1,
    marginBottom: 0,
    transform: 'none'
  }

  const generatorHeadingTransitionsSx: SystemStyleObject = {
    '.generator-heading-enter': {
      opacity: 0,
      transform: `translateY(${generatorHeadingHeight * -1}px)`,
      marginBottom: `${generatorHeadingHeight * -1}px`
    },
    '.generator-heading-enter-active': {
      ...enterActiveStyles
    },
    '.generator-heading-exit': {
      ...exitStyles
    },
    '.generator-heading-exit-active, .generator-heading-exit-done': {
      opacity: 0,
      transform: `translateY(${generatorHeadingHeight * -1}px)`,
      marginBottom: `${generatorHeadingHeight * -1}px`,
      transition
    },
    '.generator-heading-exit-done': {
      ...exitDoneStyles
    }
  }

  const codePreviewTransitionsSx: SystemStyleObject = {
    '.code-preview-enter': {
      opacity: 0,
      transform: `translateY(${codePreviewTransformDistance})`,
      marginBottom: codePreviewTransformDistance
    },
    '.code-preview-enter-active': {
      ...enterActiveStyles
    },
    '.code-preview-exit': {
      ...exitStyles
    },
    '.code-preview-exit-active, .code-preview-exit-done': {
      opacity: 0,
      transform: `translateY(${codePreviewTransformDistance})`,
      marginBottom: codePreviewTransformDistance,
      transition
    },
    '.code-preview-exit-done': {
      ...exitDoneStyles
    }
  }

  return {
    generatorHeadingRef,
    generatorHeadingTransitionsSx,
    codePreviewTransitionsSx
  }
}
